module.exports = __webpack_public_path__ + "static/media/features-hide-show.93b1134c.png";